
let reachable = true
const listeners = new Set<() => void>()

function notify() {
  for (const listener of listeners) listener()
}

export function markServerReachable(): void {
  if (reachable) return
  reachable = true
  notify()
}

export function markServerUnreachable(): void {
  if (!reachable) return
  reachable = false
  notify()
}

export function isServerReachable(): boolean {
  return reachable
}

export function isOnlineNow(): boolean {
  return navigator.onLine && reachable
}

export function subscribeToReachability(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

window.addEventListener('online', markServerReachable)
window.addEventListener('offline', markServerUnreachable)
